import React from "react";

export default function InvestimosVentures() {
    return (
        <div className="w-full bg-[#040116] py-12 md:py-20 px-8 md:px-12 flex flex-col items-center justify-center relative overflow-hidden">
            {/* Background com grafismos */}
            <div className="absolute inset-0 opacity-30 blur-xs">
                <img
                    src="/assets/grafismos.svg"
                    alt="Grafismos"
                    className="w-full h-full object-cover"
                />
                <img
                    src="/assets/grafismos.svg"
                    alt="Grafismos"
                    className="absolute inset-0 w-full h-full object-cover rotate-180"
                />
            </div>
            
            <div className="max-w-[920px] text-center space-y-8 relative z-10">
                <h2 className="text-white text-2xl md:text-[55px] font-inter-extrabold leading-[1.4] md:leading-[1.2]">
                    Investimos, co-criamos e impulsionamos negócios{" "}
                    <span className="font-inter-light text-white">
                        com alto potencial de impacto.
                    </span>
                </h2>
            </div>
        </div>
    );
}
